import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";
import { FiDownload, FiEye, FiCreditCard } from "react-icons/fi";

export default function Payroll() {
  const [filterStatus, setFilterStatus] = useState("All");

  const payrollData = [
    {
      id: 1,
      name: "John Doe",
      basic: 2000,
      allowance: 1500,
      deduction: 500,
      netSalary: 3000,
      method: "Bank Transfer",
      payDate: "2025-01-28",
      status: "Paid",
    },
    {
      id: 2,
      name: "Jane Smith",
      basic: 1800,
      allowance: 1200,
      deduction: 300,
      netSalary: 2700,
      method: "UPI",
      payDate: "2025-01-28",
      status: "Pending",
    },
    {
      id: 3,
      name: "Mike Johnson",
      basic: 2200,
      allowance: 1700,
      deduction: 400,
      netSalary: 3500,
      method: "Bank Transfer",
      payDate: "2025-01-28",
      status: "On Hold",
    },
  ];

  const filteredData =
    filterStatus === "All"
      ? payrollData
      : payrollData.filter((p) => p.status === filterStatus);

  const getStatusBadge = (status) => {
    if (status === "Paid")
      return "bg-green-100 text-green-700 px-3 py-1 rounded-full text-xs font-semibold";
    if (status === "Pending")
      return "bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full text-xs font-semibold";
    return "bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-semibold";
  };

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">
        
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Payroll</h1>

          {/* Filter */}
          <select
            className="px-4 py-2 rounded-lg border text-sm bg-white shadow"
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
          >
            <option value="All">All Status</option>
            <option value="Paid">Paid</option>
            <option value="Pending">Pending</option>
            <option value="On Hold">On Hold</option>
          </select>
        </div>

        {/* Table */}
        <Card>
          <table className="min-w-full bg-white rounded">
            <thead className="bg-gray-100 text-gray-600 text-sm uppercase">
              <tr>
                <th className="py-3 px-6 text-left">Employee</th>
                <th className="py-3 px-6 text-left">Basic</th>
                <th className="py-3 px-6 text-left">Allowance</th>
                <th className="py-3 px-6 text-left">Deduction</th>
                <th className="py-3 px-6 text-left">Net Salary</th>
                <th className="py-3 px-6 text-left">Payment Method</th>
                <th className="py-3 px-6 text-left">Pay Date</th>
                <th className="py-3 px-6 text-left">Status</th>
                <th className="py-3 px-6 text-center">Actions</th>
              </tr>
            </thead>

            <tbody className="text-gray-700 text-sm">
              {filteredData.map((p) => (
                <tr
                  key={p.id}
                  className="border-b hover:bg-gray-50 transition"
                >
                  <td className="py-3 px-6 font-medium">{p.name}</td>
                  <td className="py-3 px-6">${p.basic}</td>
                  <td className="py-3 px-6">${p.allowance}</td>
                  <td className="py-3 px-6">${p.deduction}</td>
                  <td className="py-3 px-6 font-semibold text-blue-600">
                    ${p.netSalary}
                  </td>
                  <td className="py-3 px-6">{p.method}</td>
                  <td className="py-3 px-6">{p.payDate}</td>

                  <td className="py-3 px-6">
                    <span className={getStatusBadge(p.status)}>
                      {p.status}
                    </span>
                  </td>

                  <td className="py-3 px-6 text-center">
                    <div className="flex justify-center gap-3">
                      <button
                        className="text-blue-600 hover:text-blue-800"
                        title="View Payslip"
                      >
                        <FiEye size={18} />
                      </button>

                      <button
                        className="text-green-600 hover:text-green-800"
                        title="Download Slip"
                      >
                        <FiDownload size={18} />
                      </button>

                      {p.status !== "Paid" && (
                        <button
                          className="text-purple-600 hover:text-purple-800"
                          title="Pay Now"
                        >
                          <FiCreditCard size={18} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>
    </HrLayout>
  );
}
